module.exports = __webpack_public_path__ + "static/img/444.3670b8fe.png";